import { PaginatedResponse } from '@frontend/api-utils';

export interface WorkflowField {
    id: string;
    key: WorkflowFieldKey;
    type: WorkflowFieldType;
    value: string | string[] | boolean | number | null;
    options?: string[];
    account_id: string;
    workflow_id: string;
    step_id: string;
    required?: boolean;
    description?: string | null;
}

export type WorkflowFieldListResponse = PaginatedResponse<WorkflowField>;

export interface CreateWorkflowField {
    key: WorkflowFieldKey;
    type: WorkflowFieldType;
    value: string | string[] | boolean | number | null;
}

export interface UpdateWorkflowField {
    value: string | string[] | boolean | number | null;
    null_fields?: string[] | null;
}

export enum WorkflowFieldQueryParams {
    WORKFLOW_FIELD_ID = 'workflow_field_id',
    WORKFLOW_ID = 'workflow_id',
    STEP_ID = 'step_id',
    KEY = 'key',
    TYPE = 'type',
    VALUE = 'value'
}

export enum WorkflowFieldKey {
    MODE = 'mode',
    SENDER_ID = 'sender_id',
    RECEIVER_ID = 'receiver_id',
    NOTIFICATION_TEMPLATE = 'template_id',
    DELAY_MINUTES = 'delay_minutes',
    TIME_OUT_HOURS = 'time_out_hours',
    REPEAT_HOURS = 'repeat_hours',
    USER_INTERFACE_ID = 'user_interface_id',
    PARAMETER_NAME = 'parameter_name',
    UPDATE_OPERATOR = 'update_operator',
    UPDATE_VALUE = 'update_value',
    VERIFY_OPERATOR = 'verify_operator',
    VERIFY_VALUE = 'verify_value',
    TRUE_NEXT_STATE = 'true_next_state',
    FALSE_NEXT_STATE = 'false_next_state',
    IOT = 'iot_id',
    TRIGGER = 'trigger'
}

export enum WorkflowFieldType {
    ACCESS_CONTROLLER_IDS = 'access_controller_ids',
    ANY = 'any',
    BOOL = 'bool',
    CUSTOM_ROLE_ID = 'custom_role_id',
    CONSTRAINT_MODE = 'constraint_mode',
    CONSTRAINT_TYPE = 'constraint_type',
    ENTITY_ID = 'entity_id',
    ENTITY_TYPE = 'entity_type',
    ENUM = 'enum',
    EQUIPMENT_STATE = 'equipment_state',
    FLOAT = 'float',
    FUNCTIONALITY_ID = 'functionality_id',
    INT = 'int',
    IOT_ID = 'iot_id',
    IOT_TRIGGER = 'iot_trigger',
    LABEL_TEMPLATE_ID = 'label_template_id',
    LANGUAGE = 'language',
    NOTIFICATION_TEMPLATE_ID = 'notification_template_id',
    PACKAGE_WORKFLOW_ID = 'package_workflow_id',
    PIN_CODE_RENDERING = 'pin_code_rendering',
    PIN_CODE_SOURCE = 'pin_code_source',
    PIN_CODE_TYPE = 'pin_code_type',
    PRODUCT_STATE = 'product_state',
    SPOT_ID = 'spot_id',
    STRING = 'str',
    TEMPLATE_ID = 'template_id',
    UPDATE_OPERATOR = 'update_operator',
    USER_ID = 'user_id',
    USER_IDS = 'user_ids',
    USER_GROUP_ID = 'user_group_id',
    USER_INTERFACE_ID = 'user_interface_id',
    VERIFY_OPERATOR = 'verify_operator',
    WIZARD_ID = 'wizard_id',
    WORKFLOW_VARIABLE = 'workflow_variable',

    // Not known by backend
    ENTITY_PARAMETER = 'entity_parameter',
    WORKFLOW_ID = 'workflow_id'
}
